import actions from './actions'
import {nextState, upload, uploadPrepare} from '../helper'

let initState = {
	single: {},
	loading: false,
	total: 0,
	params: {
		query: '',
		limit: 50,
		skip: 0,
	},
	data: [],
	full: []
}

export default function pageReducer(state = initState, action) {

	const {type, payload} = action

	switch (type) {

		case actions.LOAD_PAGE_SUCCESS:
			return {
				...state,
				single: payload
			}

		case actions.CHANGE_PAGE:
			return nextState({
				...state,
				single: {
					...state.single,
					...payload
				}
			})

		case actions.RESET_PAGE:
			return {
				...state,
				single: {}
			}

		//

		case actions.SEARCH_PAGE_PARAMS:
			return {
				...state,
				params: {
					...state.params,
					...payload
				}
			}

		case actions.SEARCH_PAGE_SUCCESS:
			return {
				...state,
				total: payload.total,
				data: payload.data
			}

		case actions.UPLOAD_PAGE:
			return nextState({
				...state,
				single: uploadPrepare(state.single, payload)
			})

		case actions.UPLOAD_PAGE_SUCCESS:
			return nextState({
				...state,
				single: upload(state.single, payload)
			})

		case actions.REMOVE_PAGE:
			return {
				...state,
				data: state.data.filter(rec => rec._id !== payload)
			}

		default:
			return state
	}
}
